import React from "react";
import { Box } from "@mui/material";
import { useAddendumAssociations } from "../../../hooks/useAddendumAssociations";

// Mirrors the `.addendumAssociationsSkeleton` shimmer used elsewhere in the
// codebase (e.g. AttachmentRow.scss) - kept as an `sx` object here since this
// component tree has no scss file and styles everything inline.
const releaseFlowVersionSkeletonSx = {
  display: "inline-block",
  width: "72px",
  height: "12px",
  borderRadius: "6px",
  background: "linear-gradient(90deg, #eef0f8 0%, #dfe2f0 50%, #eef0f8 100%)",
  backgroundSize: "200% 100%",
  animation: "addendumSkeletonLoading 1.2s ease-in-out infinite",
  "@keyframes addendumSkeletonLoading": {
    "0%": { backgroundPosition: "200% 0" },
    "100%": { backgroundPosition: "-200% 0" },
  },
};

// Adendos have no version number of their own - show the chapter/episode
// association label (e.g. "CAP. 20, 22") instead of "undefinedª Versão".
// `isChapterAddendum` comes pre-tagged on the attachment itself (set where
// each pipeline already knows chapter vs episode/material origin), so this
// component doesn't need the project's format at all. Shared between
// ReleaseFlowStepDestinations (step 1) and ReleaseFlowStepVersions (step 2).
export const ReleaseFlowVersionLabel = ({ attachment }) => {
  const isAdendo = attachment?.type === "Adendo";
  const addendumId = attachment?.id ?? attachment?.attachmentId;

  const { addendumAssociations, isLoadingAddendumAssociations } =
    useAddendumAssociations({
      isAdendo,
      addendumId,
      isChapter: attachment?.isChapterAddendum,
    });

  if (!isAdendo) return `${attachment.versionNumber}ª Versão`;

  if (isLoadingAddendumAssociations) {
    return <Box component="span" sx={releaseFlowVersionSkeletonSx} />;
  }

  return addendumAssociations || "-";
};

export default ReleaseFlowVersionLabel;
